// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freeVip_message_dialog[data-v-11d00d27]{position:absolute;top:0;right:0;bottom:0;left:0;padding-top:35px;text-align:center}.freeVip_message_dialog .freeVip_message_title[data-v-11d00d27]{position:relative;top:0;font-size:12px;color:#4a96e8;text-align:center}.freeVip_message_dialog .freeVip_message_btn[data-v-11d00d27]{position:relative;top:30px}", ""]);
// Exports
module.exports = exports;
